import React, { useEffect, useState } from "react";
import { Icon } from "@fluentui/react/lib/Icon";
import dompurify from "dompurify";
import { v4 as uniqueIdGenerator } from "uuid";
import TasksCKEditorLink from '../NewActivityDetailsPage/TasksCKEditorLink';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { toast } from 'react-toastify';

const TaskContribution = ({
  contributorsData,
  taskButtonClicked,
  setTaskButtonClicked,
  ckEditorUserMap,
  CkEditorCurrentUser,
  taskSuggestions,
  setTaskSuggestions,
  taskWithSuggestions,
  setTaskWithSuggestions,
  reviewedTaskSuggestions,
  setReviewedTaskSuggestions,
  reviewerTaskSuggestions,
  reviewedReorderedTaskSuggestions,
  setReviewedReorderedTaskSuggestions,
  source,
  taskData,
  setTaskData,
  taskReorder,
  setTaskReorder,
  setTaskReorderArray,
  taskReorderArray,
  initialTaskIdBeforeReorder,
  setInitialTaskIdBeforeReorder,
  disableDrag,
  setDisableDrag,
  ckEditorCurrentReorderUsername,
  setCkEditorCurrentReorderUsername,
  ckEditorCurrentReorderUserImage,
  setCkEditorCurrentReorderUserImage,
  user,
  setIsReviewerTaskReordered,
  setIsApproverTaskReordered,
  setReorderContributionCount,
  setAddedTaskSequence,
  setIsOrderChanged,
  pageTypeCalling,
  disableControls
}) => {

  const pageType = ['review', 'approve'];
  const htmlSanitizer = (data) => {
    const config = {
      ADD_ATTR: [ 'target'],
      };
    return dompurify.sanitize(data, config);
  };
  const [taskName, setTaskName] = useState("");
  const [taskDescription, setTaskDescription] = useState("");
  const [error, setError] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [updateId, setUpdateId] = useState(0);
  const [taskList, setTaskList] = useState([...contributorsData.taskList]);
  const [toolsSidebarHeight, setToolsSidebarHeight] = useState("59px");
  const [userImgWithReorder, setUserImgWithReorder] = useState(null)
  const [userNameWithReorder, setUserNameWithReorder] = useState(null)
  const [taskListwithInsert,  setTaskListwithInsert] = useState([...contributorsData.taskList])
  const [contributorReorderName, setContributorReorderName] = useState('')
  const [contributorReorderImage, setContributorReorderImage] = useState('')  

  // const updateTask = () => {
  //   if (taskDescription !== '' && taskDescription.trim().length !== 0) {
  //     if (editMode) {
  //       if (taskList.some((item) => item.id === updateId)) {
  //         const updatedDtails = taskWithSuggestions.map((item) =>
  //           JSON.parse(item).id === updateId
  //             ? JSON.stringify({
  //               ...JSON.parse(item),
  //               suggestionType:"updation",
  //               suggestionId: uniqueIdGenerator(),
  //               authorId: CkEditorCurrentUser,
  //               createdAt: new Date(),
  //               name: taskDescription,
  //             })
  //             : item
  //         );
  //         setTaskWithSuggestions([...updatedDtails]);
  //         if (!taskSuggestions.some((item) => JSON.parse(item).id === updateId)) {
  //           const task = taskList
  //             .filter((item) => item.id === updateId)
  //             .map((value) => {
  //               return JSON.stringify({
  //                 ...value,
  //                 suggestionType:"updation",
  //                 suggestionId: uniqueIdGenerator(),
  //                 authorId: CkEditorCurrentUser,
  //                 createdAt: new Date(),
  //                 name: taskDescription,
  //               });
  //             });
  //           setTaskSuggestions((prevState) => [...prevState, ...task]);
  //         } else {
  //           const updatedSuggestions = taskSuggestions.map((item) =>
  //             JSON.parse(item).id === updateId
  //               ? JSON.stringify({
  //                 ...JSON.parse(item),
  //                 suggestionType:"updation",
  //                 suggestionId: uniqueIdGenerator(),
  //                 authorId: CkEditorCurrentUser,
  //                 createdAt: new Date(),
  //                 name: taskDescription,
  //               })
  //               : item
  //           );
  //           setTaskSuggestions([...updatedSuggestions]);
  //         }
  //       } else {
  //         const updatedDtails = taskWithSuggestions.map((item) =>
  //           JSON.parse(item).id === updateId
  //             ? JSON.stringify({
  //               ...JSON.parse(item),
  //               authorId: CkEditorCurrentUser,
  //               createdAt: new Date(),
  //               name: taskDescription,
  //             })
  //             : item
  //         );
  //         const updateSuggestions = taskSuggestions.map((item) =>
  //           JSON.parse(item).id === updateId
  //             ? JSON.stringify({
  //               ...JSON.parse(item),
  //               authorId: CkEditorCurrentUser,
  //               createdAt: new Date(),
  //               name: taskDescription,
  //             })
  //             : item
  //         );
  //         setTaskSuggestions([...updateSuggestions]);
  //         setTaskWithSuggestions([...updatedDtails]);
  //       }
  //       setEditMode(false);
  //       setTaskDescription("");
  //       setUpdateId(0);
  //       setTaskName("");
  //       setError(false);
  //     } else {
  //       const task = {
  //         id: uniqueIdGenerator(),
  //         suggestionId: uniqueIdGenerator(),
  //         name: taskDescription,
  //         status: "new",
  //         suggestionType: "insertion",
  //         authorId: CkEditorCurrentUser,
  //         createdAt: new Date(),
  //         sequence: taskWithSuggestions.length + 1
  //       };
  //       if(taskReorderArray.length !== 0){
  //         const insertionId =  {id: task.id, name: task.name}
  //         setTaskReorderArray(prev=> [...prev, JSON.stringify(insertionId)])
  //       }
  //       setTaskListwithInsert([...taskListwithInsert, task])
  //       const taskJson = JSON.stringify(task);
  //       setAddedTaskSequence(prev=>[...prev, {id:JSON.parse(taskJson).id,
  //                                sequence:JSON.parse(taskJson).sequence}])
  //       setTaskSuggestions([...taskSuggestions, taskJson]);
  //       setTaskWithSuggestions([...taskWithSuggestions, taskJson]);
  //       setInitialTaskIdBeforeReorder([...initialTaskIdBeforeReorder, taskJson])
  //       setTaskName("");
  //       setTaskDescription("");
  //       setError(false);
  //     }
  //   } else {
  //     setError(true);
  //   }
  // };
 

  const deleteOtherDetails = (item) => {
    const task = {
      ...item,
      suggestionId: uniqueIdGenerator(),
      suggestionType: "deletion",
      authorId: CkEditorCurrentUser,
      createdAt: new Date(),
    };
    const taskJson = JSON.stringify(task);

    setTaskSuggestions([taskJson, ...taskSuggestions]);

    const updatedSuggestions = taskWithSuggestions.map((value) =>
      JSON.parse(value).id !== item.id
        ? value
        : JSON.stringify({
          ...JSON.parse(value),
          suggestionId: uniqueIdGenerator(),
          suggestionType: "deletion",
          authorId: CkEditorCurrentUser,
          createdAt: new Date(),
        })
    );
    setTaskWithSuggestions([...updatedSuggestions]);
    // setInitialTaskIdBeforeReorder([...updatedSuggestions])
  };
  
  const acceptSuggestion = (value) => {
    if (JSON.parse(value).suggestionType === 'deletion') {
      if(taskReorder && ckEditorCurrentReorderUsername !== user.profile.firstName + ' '+user.profile.surname 
        && JSON.parse(value).suggestionType==='deletion'){
        const initialTask = initialTaskIdBeforeReorder.filter(e=> JSON.parse(e).id !== JSON.parse(value).id).map(e=>JSON.parse(e).id)
        const currentTask = taskWithSuggestions.filter(e=> JSON.parse(e).id !== JSON.parse(value).id).map(e=>JSON.parse(e).id)
        const isSimilar = initialTask.some((element, index) => element !== currentTask[index])
        if(!isSimilar){
          removeReorderedSuggestions();
          toast.info('Reorder suggestion has rejected automatically', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      }
      if (taskList.some((item) => item.id === JSON.parse(value).id)) {
        const updatedTask = taskList.filter(
          (item) => item.id !== JSON.parse(value).id
        );
        setTaskList([...updatedTask]);
        const updatedDataList = taskData.filter(
          (item) => item.id !== JSON.parse(value).id
        );
        setTaskData([...updatedDataList]);
        const filteredList = taskWithSuggestions.filter(
          (item) => JSON.parse(item).id !== JSON.parse(value).id
        );
        setTaskWithSuggestions([...filteredList]);
        setInitialTaskIdBeforeReorder(prev=> prev.filter(e=>JSON.parse(e).id !== JSON.parse(value).id))
        if(taskReorderArray !== null){
          setTaskReorderArray(prev=>prev.filter(e=>JSON.parse(e).id !== JSON.parse(value).id))
        }
   
      } else {
        const filteredList = taskWithSuggestions.filter(
          (item) => JSON.parse(item).id !== JSON.parse(value).id
        );
        setTaskSuggestions([...filteredList]);
      }
    } else {
      const updatedList = taskWithSuggestions.map((item) =>
        JSON.parse(item).id === JSON.parse(value).id
          ? JSON.stringify({
            ...JSON.parse(item),
            suggestionType: 'none',
            suggestionId: null,
            authorId: CkEditorCurrentUser,
            createdAt: new Date(),
          })
          : item
      );
      setTaskWithSuggestions([...updatedList]);
      if (!taskList.some((item) => item.id === JSON.parse(value).id)) {
        const criteria = {
          id: JSON.parse(value).id,
          name: JSON.parse(value).name,
          activityId:JSON.parse(value).activityId,
          complexityId:JSON.parse(value).complexityId,
          description:JSON.parse(value).description,
          createdDate: JSON.parse(value).createdDate,
          createdBy: JSON.parse(value).authorId,
          sequence: taskList.indexOf(taskList.length-1) + 2
        };
        const updatedTaskData = ([...taskData, criteria])
        updatedTaskData.map((e,i)=>{
         return e.sequence = i + 1;
        })
        setTaskData(updatedTaskData);
        setTaskList([...taskList, criteria]);
      } else {
        const updatedList = taskList.map((item) =>  
          item.id === JSON.parse(value).id ? JSON.parse(value) : item
        );
        setTaskList([...updatedList]);
        const updatedData = taskData.map((item) =>
          item.id === JSON.parse(value).id ? JSON.parse(value) : item
        );
        setTaskData([...updatedData]);
      }
    }

    const filteredValue = taskSuggestions.filter(
      (item) => JSON.parse(item).id !== JSON.parse(value).id
    );
    setTaskSuggestions([...filteredValue]);

    setReviewedTaskSuggestions([
      ...reviewedTaskSuggestions,
      JSON.stringify({ id: JSON.parse(value).id, state: 'accepted' }),
    ]);
    
  };
 
  const removeSuggestion = (value) => {
    const filteredValue = taskSuggestions.filter(
      (item) => JSON.parse(item).id !== JSON.parse(value).id
    );
    setTaskSuggestions([...filteredValue]);


    if (
      pageType.includes(source) &&
      JSON.parse(value).authorId !== CkEditorCurrentUser
    ) {
      setReviewedTaskSuggestions([
        ...reviewedTaskSuggestions,
        JSON.stringify({ id: JSON.parse(value).id, state: 'rejected' }),
      ]);
      if(taskReorder && ckEditorCurrentReorderUsername !== user.profile.firstName + ' '+user.profile.surname 
        && JSON.parse(value).suggestionType==='insertion'){
        const initialTask = initialTaskIdBeforeReorder.filter(e=> JSON.parse(e).id !== JSON.parse(value).id).map(e=>JSON.parse(e).id)
        const currentTask = taskWithSuggestions.filter(e=> JSON.parse(e).id !== JSON.parse(value).id).map(e=>JSON.parse(e).id)
        const isSimilar = initialTask.some((element, index) => element !== currentTask[index])
        if(!isSimilar){
          removeReorderedSuggestions();
          toast.info('Reorder suggestion has rejected automatically', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      }
    }
    if (
      source === 'approve'
      && JSON.parse(value).authorId === CkEditorCurrentUser
      && reviewerTaskSuggestions?.some((item) => JSON.parse(item).id === JSON.parse(value).id)
    ) {
      setReviewedTaskSuggestions([
        ...reviewedTaskSuggestions,
        JSON.stringify({ id: JSON.parse(value).id, state: 'rejected' }),
      ]);
    }

    if (taskList.some((item) => item.id === JSON.parse(value).id)) {
      const filteredList = taskWithSuggestions.filter(
        (item) => JSON.parse(item).id !== JSON.parse(value).id
      );
          const exit = taskList
          .filter((item) => JSON.parse(value).id === item.id)
          .map((exit) => {
            return JSON.stringify({
              ...exit,
              suggestionType: "none",
              authorId: CkEditorCurrentUser,
              suggestionId: null,
              createdAt: new Date(),
            });
          });
        const updatedList = taskWithSuggestions.map((item) =>
          JSON.parse(item).id === JSON.parse(value).id
            ? JSON.stringify({
              ...taskList.filter((item) => JSON.parse(value).id === item.id)[0],
              suggestionType: "none",
              suggestionId: null,
              authorId: CkEditorCurrentUser,
              createdAt: new Date(),
            })
            : item
        );

       setTaskWithSuggestions([...updatedList]);
       const updatedInitialList = initialTaskIdBeforeReorder.map((item) =>
          JSON.parse(item).id === JSON.parse(value).id
            ? JSON.stringify({
              ...taskList.filter((item) => JSON.parse(value).id === item.id)[0],
              suggestionType: "none",
              suggestionId: null,
              authorId: CkEditorCurrentUser,
              createdAt: new Date(),
            })
            : item
        );
       setInitialTaskIdBeforeReorder([...updatedInitialList])

      
    } else {
      const filteredList = taskWithSuggestions.filter(
        (item) => JSON.parse(item).id !== JSON.parse(value).id
        );
      const fileredInitialList = initialTaskIdBeforeReorder.filter(
        (item)=> JSON.parse(item).id !== JSON.parse(value).id
      );  
      setTaskWithSuggestions([...filteredList]);
      setInitialTaskIdBeforeReorder(prev=> prev.filter(e=>JSON.parse(e).id !== JSON.parse(value).id))
      setTaskListwithInsert([...fileredInitialList.map(e=>JSON.parse(e))])
      setTaskReorderArray(prev=> prev.filter(e=>JSON.parse(e).id !== JSON.parse(value).id))
      


    }
    
  };
 
  const handletaskDescription = (event) => {
    setTaskDescription(event.target.value);
  };
  function removePTags(html) {
		// Replace all <p> tags with an empty string
		return html.replace(/<p>/g, '').replace(/<\/p>/g, '');
	  }

    const removeReorderedSuggestions = ()=>{
      const parsedTasks = taskWithSuggestions.map((item) => {
        return JSON.parse(item)
      })
      const parsedinitialTaskIdBeforeReorder = initialTaskIdBeforeReorder.map((item)=>{
        return JSON.parse(item)
      })
      const parsedArray = parsedTasks.map((item) => {
        return JSON.stringify({
          ...item,
           sequence: parsedinitialTaskIdBeforeReorder.filter((v) => v.id === item.id)[0]?.sequence,
           authorId: item.authorId !== CkEditorCurrentUser ? item.authorId :CkEditorCurrentUser,
          createdAt: new Date(),
        })
      })
      const beforeSortingArray = parsedArray.map((item) => {
        return JSON.parse(item)
      })
      beforeSortingArray.sort((a, b) => a.sequence - b.sequence)
      const afterSortAndStringify = beforeSortingArray.map((item) => {
        return JSON.stringify(item)
      })
      setTaskWithSuggestions([...afterSortAndStringify]);
      setTaskReorder(false)
      setTaskReorderArray([])
      if(source === 'review'){
				setIsReviewerTaskReordered(false)
			}
      if(source === 'approve'){
        setIsApproverTaskReordered(false)
      }
      if (
        pageType.includes(source) && ckEditorCurrentReorderUsername !== user.profile.firstName + ' '+ user.profile.surname
        
      ) {
        setReviewedReorderedTaskSuggestions([JSON.stringify({ id: uniqueIdGenerator(), state: 'rejected',name:'Task' })]);
        setTaskReorderArray([])
        setReorderContributionCount((prev)=> prev - 1)

      }
      setDisableDrag(false)
  }

  useEffect(()=>{

      const   arraysAreEqual = (arr1, arr2)=> {
      const beforeReorderId = arr1.map(e=> JSON.parse(e).id)
      const afterReorderId = arr2.map(e=> JSON.parse(e).id)
      if (beforeReorderId.length !== afterReorderId.length) {
        return false;
      }
    return beforeReorderId.some((element, index) => element !== afterReorderId[index]);
    }
    const orderHasChanged = arraysAreEqual(initialTaskIdBeforeReorder, taskWithSuggestions);
     setTaskReorder(orderHasChanged)
     setIsOrderChanged(prevState => ({
      ...prevState,
      task: orderHasChanged 
    }))

  },[taskWithSuggestions])


  const onDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(taskWithSuggestions);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    let author;
    const taskArray=[];
    const finalArray = items.map((item, index) => { 
      const parsedItem = JSON.parse(item)
      taskArray.push({id: parsedItem.id,name:parsedItem.name,authorId: [user.profile.firstName + ' '+user.profile.surname,user.profile.photo],
        createdAt: new Date()})
      author = parsedItem.authorId
      parsedItem.sequence = index + 1;
      return JSON.stringify(parsedItem)
    })
    setCkEditorCurrentReorderUserImage(user.profile.photo)
    setCkEditorCurrentReorderUsername(user.profile.firstName + ' '+user.profile.surname)
    setTaskWithSuggestions(finalArray);
    const taskArrayString = taskArray.map(e=> JSON.stringify(e))
    setTaskReorderArray(taskArrayString)
    if(source === 'review'){
      setIsReviewerTaskReordered(true)
    }
    if(source === 'approve'){
      setIsApproverTaskReordered(true)
    }
  };


 const acceptReorderSuggestion=()=>{
  const isNotCurrentUser = taskSuggestions.some(e=>JSON.parse(e).authorId !== CkEditorCurrentUser )
  if(taskSuggestions && taskSuggestions.length !==0 && isNotCurrentUser){
      toast.error('Please accept or reject other Tasks suggestions before accepting reorder', {
        position: toast.POSITION.TOP_RIGHT,
      });
  } else {
    setReviewedReorderedTaskSuggestions([JSON.stringify({ id: uniqueIdGenerator(), state: 'accepted',name:'Task' })])
    setTaskReorder(false);
    setInitialTaskIdBeforeReorder(taskWithSuggestions)
    setReorderContributionCount((prev)=> prev - 1)
   
 }

  }
 const renderSuggestions = () => {
    return (
      <div className="toolsSidebar" style={{ minHeight: toolsSidebarHeight, maxHeight:'50%' }}>
        {
          taskReorder &&  <>
          <div className="sideBarCard userAddedItem">
          <div className="sideBarCardHeader">
                    <img
                      className="userImg"
                      src={ckEditorCurrentReorderUserImage}
                      alt=""
                    />
                    <span>{ckEditorCurrentReorderUsername}</span>
                    <Icon
                        title="Reject Suggestion"
                        ariaLabel={`Click to reject the Reorder`}
                        role="button"
                        iconName="Cancel"
                        onClick={() => removeReorderedSuggestions()}
                        onKeyPress={(e) => {
                          if (e.which === 13) {
                            removeReorderedSuggestions();
                          }
                        }}
                        tabIndex={0}
                      />
                    {pageType.includes(source) && 
                    ckEditorCurrentReorderUsername !== user.profile.firstName + ' '+user.profile.surname &&
                      (
                      <Icon
                        title="Accept Suggestion"
                        iconName="Accept"
                        onClick={() => acceptReorderSuggestion()}
                        onKeyPress={(e) => {
                          if (e.which === 13) {
                            acceptReorderSuggestion();
                          }
                        }}
                        ariaLabel={'click to accept as suggestion'}
                        role="button"
                        tabIndex={0}
                      />
                    
                    )}
                    
                    <div className="itemStatus">
                    <span>
                     Reordered
                    </span>
                    &nbsp;"Description: Tasks has been Reordered"
                  </div>
                  
                  </div>
                  </div>
          
          </>
        }
        {taskSuggestions &&
          taskWithSuggestions.map((card) => (
            <>
              {JSON.parse(card).suggestionType === "none" ? (
                <></>
              ) : (
                <div
                  className={`sideBarCard ${JSON.parse(card).suggestionType === "deletion"
                    ? 'userDeletedToolsAndGuidance'
                    : 'userAddedItem'
                    }`}
                >
                  <div className="sideBarCardHeader">
                    <img
                      className="userImg"
                      src={ckEditorUserMap[JSON.parse(card).authorId][1]}
                      alt=""
                    />
                    <span className="nonCkEditorAuthor">{ckEditorUserMap[JSON.parse(card).authorId][0]}</span>

                    {JSON.parse(card).authorId === CkEditorCurrentUser ||
                      (pageType.includes(source) &&
                        JSON.parse(card).authorId !== CkEditorCurrentUser) ? (
                      <Icon
                        title="Reject Suggestion"
                        ariaLabel={`Click to reject ${JSON.parse(card).name
                          } as suggestion`}
                        role="button"
                        iconName="Cancel"
                        onClick={() => removeSuggestion(card)}
                        onKeyPress={(e) => {
                          if (e.which === 13) {
                            removeSuggestion(card);
                          }
                        }}
                        tabIndex={0}
                      />
                    ) : (
                      <></>
                    )}
                    {pageType.includes(source) &&
                      JSON.parse(card).authorId !== CkEditorCurrentUser ? (
                        
                      <Icon
                        title="Accept Suggestion"
                        iconName="Accept"
                        onClick={() => acceptSuggestion(card)}
                        onKeyPress={(e) => {
                          if (e.which === 13) {
                            acceptSuggestion(card);
                          }
                        }}
                        ariaLabel={`Click to Accept ${JSON.parse(card).name
                          } as suggestion`}
                        role="button"
                        tabIndex={0}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="itemStatus">
                    <span>
                      {JSON.parse(card).suggestionType === "insertion"
                        ? "Add"
                        : JSON.parse(card).suggestionType === "deletion"
                          ? "Remove"
                          : JSON.parse(card).suggestionType === "Reorder" ? "Reordered" : "Edit"}
                    </span>
                    &nbsp;
                     Description:  
                   <span dangerouslySetInnerHTML={{ __html: htmlSanitizer(removePTags(JSON.parse(card).name)) }} />
                  </div>
                </div>
              )}
            </>
          ))}
      </div>
    );
  };

  const addTask = () => {
    const newTask = {
      id: uniqueIdGenerator(),
      suggestionId: uniqueIdGenerator(),
      name: "",
      status: "new",
      suggestionType: "insertion",
      authorId: CkEditorCurrentUser,
      createdAt: new Date(),
    };
    setTaskWithSuggestions([...taskWithSuggestions, JSON.stringify(newTask)]);
  };

  const addNewTaskIfNeeded = () => {
    setTaskWithSuggestions((prevList) => {
      if (prevList.length === 0) {
        const newTask = JSON.stringify(createNewTask());
        setTaskSuggestions([newTask]); // Ensure taskSuggestions has the same task
        return [newTask];
      }
  
      const lastTask = JSON.parse(prevList[prevList.length - 1]);
      const lastTaskName = lastTask.name.replace(/<p>(.*?)<\/p>/, "$1").trim();
  
      if (lastTaskName !== "") {
        console.log("Last task is not empty, adding a new blank row.");
        const newTask = JSON.stringify(createNewTask());
        setTaskSuggestions((prev) => [...prev, newTask]); // Add to taskSuggestions
        return [...prevList, newTask];
      }
  
      console.log("Last task is empty, no new row added.");
      return prevList;
    });
  };
  
  
  // Function to create a new task
  const createNewTask = () => ({
    id: uniqueIdGenerator(),
    suggestionId: uniqueIdGenerator(),
    name: "", // Blank task
    status: "new",
    suggestionType: "insertion",
    authorId: CkEditorCurrentUser,
    createdAt: new Date(),
  });
  

console.log('DTX-taskList',taskList)
console.log('DTX-taskSuggestions',taskSuggestions)
console.log('DTX-taskWithSuggestions',taskWithSuggestions)

const [isRemovalRow, setIsRemovalRow] = useState(null); // Use null instead of false

useEffect(() => {
  if (isRemovalRow !== null) {
    updateTask(isRemovalRow.index, isRemovalRow.value);
    setIsRemovalRow(null); // Reset flag after processing
  }
}, [isRemovalRow]); 
const updateTask = (index, value) => {
  const updatedList = [...taskWithSuggestions];
  const task = JSON.parse(updatedList[index]);
  const originalTask = taskList.find((item) => item.id === task.id);
  const strippedValue = value.replace(/<p>(.*?)<\/p>/, "$1");

  if (originalTask && originalTask.name === strippedValue) {
    task.suggestionType = "none";
    task.suggestionId = null;
  } else {
    task.name = value;
    task.suggestionType = "updation";
    task.suggestionId = uniqueIdGenerator();
    task.authorId = CkEditorCurrentUser;
    task.createdAt = new Date();
  }

  updatedList[index] = JSON.stringify(task);
  setTaskWithSuggestions(updatedList);

  // Ensure `taskSuggestions` is updated properly
  setTaskSuggestions((prevSuggestions) => {
    const taskExists = prevSuggestions.some(
      (item) => JSON.parse(item).id === task.id
    );

    if (!taskExists) {
      return [...prevSuggestions, JSON.stringify(task)];
    }

    return prevSuggestions.map((item) =>
      JSON.parse(item).id === task.id ? JSON.stringify(task) : item
    );
  });
};


const deleteTask = (index) => {
  setTaskWithSuggestions((prevList) => {
    const updatedList = [...prevList];
    const task = JSON.parse(updatedList[index]);

    console.log("Deleting Task:", task); // Debugging log

    // 🟢 Case 1: If it's a newly added task (insertion), remove it completely
    if (task.suggestionType === "insertion" || task.status === "new") {
      console.log("Removing newly inserted task at index:", index);
      updatedList.splice(index, 1);

      // ❗ Ensure it's also removed from `taskSuggestions`
      setTaskSuggestions((prevSuggestions) => 
        prevSuggestions.filter((item) => JSON.parse(item).id !== task.id)
      );

      return [...updatedList]; // Ensure state updates
    }

    // 🔴 Case 2: Find the original task
    const originalTask = taskList.find((item) => item.id === task.id);
    if (!originalTask) {
      console.warn("Original task not found! Unable to revert.");
      return prevList; // Exit if the original task is missing
    }

    console.log("Original Task Found:", originalTask);

    const strippedTaskName = task.name.replace(/<p>(.*?)<\/p>/, "$1").trim();
    const strippedOriginalName = originalTask.name.replace(/<p>(.*?)<\/p>/, "$1").trim();

    // 🟡 Case 3: If the task has changes, revert only the changes and set as "none"
    if (strippedOriginalName !== strippedTaskName) {
      console.log("Reverting only changes, keeping task");

      updatedList[index] = JSON.stringify({
        ...originalTask, // Restore original content
        suggestionType: "none", // Reset to no suggestion
        suggestionId: null,
      });

      
      setIsRemovalRow({ index, value: originalTask.name });
    } else if (strippedOriginalName === strippedTaskName) {
      // 🟠 Case 4: If the task was already original, mark it for deletion
      console.log("Task unchanged, marking as deletion");
      updatedList[index] = JSON.stringify({
        ...task,
        suggestionId: uniqueIdGenerator(),
        suggestionType: "deletion",
        authorId: CkEditorCurrentUser,
        createdAt: new Date(),
      });
    }

    return [...updatedList]; // Ensure React detects the state change
  });

  // 🔍 Debugging: Check if the state updates
  setTimeout(() => {
    console.log("Updated taskWithSuggestions (After Remove):", taskWithSuggestions);
  }, 500);
};


return (
  <div id={"taskInputBox"} className={`d-flex`}>
    <div className="_taskRow">
      {taskWithSuggestions.map((item, index) => (
        <div key={JSON.parse(item).id}>
          <div className="addPolygonTopicRelatedInputContainer pb-0">
            <div className="polygonInputContainer">
              <div className="row" style={{ paddingTop: "13px", marginLeft: "-23px" }}>
                <div className={`inputBox p-0`}>
                  <TasksCKEditorLink
                    value={JSON.parse(taskWithSuggestions[index]).name}
                    setValue={(value) => updateTask(index, value, false)}
                    pageTypeCalling={pageTypeCalling}
                    readonly={disableControls}
                  />
                </div>
                <div
                  className="d-flex justify-content-center align-items-end"
                  style={{ marginBottom: "-5.5px", paddingLeft: "11px" }}
                >
                  <div className="addPolygonTopicFieldSave mt-2">
                    <button
                      disabled={disableControls}
                      tabIndex={0}
                      title="Remove"
                      role="button"
                      aria-label="Remove"
                      className={disableControls ? "disableIconsCross relatededitContentDelete" : "relatededitContentDelete"}
                      onClick={() => {
                        // setIsRemovalRow(true);
                        deleteTask(index)
                      }}
                    ></button>
                  </div>
                  {index === taskWithSuggestions.length - 1 && (
                    <div className="addPolygonTopicFieldSave mt-2">
                      <button
  disabled={disableControls}
  tabIndex={0}
  title="Add"
  role="button"
  aria-label="Add"
  className={disableControls ? "disableIconsAdd relatedContentAdd" : "relatedContentAdd"}
  onClick={addNewTaskIfNeeded} // Use the function here
></button>

                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
    {renderSuggestions(ckEditorUserMap)}
  </div>
);
};

export default TaskContribution;
